import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { TutorialService } from "../services/tutorial.service";

@Injectable({
  providedIn: 'root'
})
export class TutorialResolver implements Resolve<boolean> {

  constructor(private service: TutorialService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}


@Injectable({
  providedIn: 'root'
})
export class TutorialPermissionResolver implements Resolve<boolean> {

  constructor(private service: TutorialService) { }

  resolve(): Observable<any> {
    return this.service.getPermission();
  }
}